import { render, staticRenderFns } from "./Amount.vue?vue&type=template&id=2eb2f6c4&scoped=true"
import script from "./Amount.vue?vue&type=script&lang=js"
export * from "./Amount.vue?vue&type=script&lang=js"
import style0 from "./Amount.vue?vue&type=style&index=0&id=2eb2f6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb2f6c4",
  null
  
)

export default component.exports